import { criarSessao } from "@mtc/ui";

/** O que o backend devolve em GET /v1/me. */
export type Pessoa = {
  id: string;
  cpf: string;
  nome: string;
  /** Celular da conta, quando houver: o checkout traz preenchido (spec 045, 3.4). */
  telefone?: string | null;
  emails: { id: string; email: string; principal: boolean; verificado: boolean; origem: string }[];
  acesso: { senha_definida_em: string | null; ultimo_login_em: string | null };
  /** `ocultas`: as partes da area que o administrador desligou (spec 060), pelo endereco sem a barra. */
  capacidades: { marca: string; modulos: string[]; ambiente?: string; ocultas?: string[] };
  /** Sessao assistida (spec 012): a equipe esta vendo esta area; a faixa no topo diz quem e por quanto tempo. */
  assistido?: { operador: string; expira_em: string } | null;
};

export const { ProvedorSessao, useSessao } = criarSessao<Pessoa>({ renovar: "/v1/auth/renovar", sair: "/v1/auth/sair", eu: "/v1/me" });
